import gql from "graphql-tag";

export const joinGamePlayGQL = gql`
  mutation JoinGamePlay($input: JoinGamePlayInput!) {
    joinGamePlay(input: $input) {
      message
      gameSession {
        id
        status
        launchData {
          ... on CasualHtmlLaunchData {
            __typename
            gameConfig
            launchUrl
          }
          ... on N2IStreamLaunchData {
            __typename
            launchUrl
            sessionId
          }
          ... on PCStreamLaunchData {
            __typename
            city
            country
            launchUrl
            streamStatusUrl
            time
            date
            bitrate
          }
          ... on BlacknutStreamLaunchData {
            __typename
            accessToken
            blacknutGameId
            refreshToken
          }
        }
        game {
          data
          id
          type
          orientation
          title
          category
        }
      }
      gamePlay {
        status
        id
        mode
        providerGameId
      }
      gameParticipant {
        id
        status
      }
    }
  }
`;

export const startGamePlayGQL = gql`
  mutation startGamePlay($input: StartGamePlayInput) {
    startGamePlay(input: $input) {
      message
    }
  }
`;

export const endGamePlayGql = gql`
  mutation endGamePlay($input: EndGamePlayInput!) {
    endGamePlay(input: $input) {
      gameParticipant {
        id
        status
        prize {
          amount
          itemType
          walletType
        }
      }
      gamePlay {
        id
        mode
        status
      }
      gameSession {
        id
        status
      }
    }
  }
`;

export const submitGameplayFeedbackGql = gql`
  mutation SubmitGameplayFeedback($input: SubmitGameplayFeedbackInput!) {
    submitGameplayFeedback(input: $input) {
      message
    }
  }
`;

export const exitGameQueueGql = gql`
  mutation ExitGameQueue {
    exitGameQueue {
      message
    }
  }
`;

export const disconnectStreamGql = gql`
  mutation DisconnectStream($input: DisconnectStreamInput!) {
    disconnectStream(input: $input) {
      message
    }
  }
`;
